import { PureComponent } from "react";
import { Menu } from "semantic-ui-react";
import ProtoTypes from 'prop-types';

class AppMenu extends PureComponent {
    handleItemClick = (e, { name }) => {
        this.props.onClick(e, { name })
    }

    render() {
        const { activeItem } = this.props;
        return <Menu attached tabular>
            <Menu.Item
                name='home'
                active={activeItem === 'home'}
                onClick={this.handleItemClick}
            />
            <Menu.Item
                name='blogs'
                active={activeItem === 'blogs'}
                onClick={this.handleItemClick}
            />
            <Menu.Item
                name='projects'
                active={activeItem === 'projects'}
                onClick={this.handleItemClick}
            />
            {/* <Menu.Menu position='right'>
                <Menu.Item>
                    <Input icon='search' placeholder='Search...' />
                </Menu.Item>
            </Menu.Menu> */}
        </Menu>
    }
}

AppMenu.protoTypes = {
    onClick: ProtoTypes.func,
    activeItem: ProtoTypes.string
}

AppMenu.defaultProps = {
    onClick: () => { },
    activeItem: ""
}

export default AppMenu;